var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isOAuth)?_c('div',{attrs:{"id":"app"}},[(_vm.visible)?_c('div',{staticClass:"main-container"},[_c(_vm.layout,{tag:"component"})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }